import React from "react"

export const InnerHtmlComponent = text => (
  // eslint-disable-next-line react/no-danger
  <div dangerouslySetInnerHTML={{__html: text}} />
)